import { Map as LMap } from 'leaflet';
import Factory from './common/Factory';
import ImageLoader from './components/ImageLoader';
import TileManager from './components/TileManager';
import FeatureSelector from './components/FeatureSelector';
import GeojsonConverter from './components/GeojsonConverter';
import SourceController from './source/SourceController';
import FeedbackController from './feedback/FeedbackController';
import HighlightController from './highlight/HighlightController';
import IDHighlightController from './highlight/IDHighlightController';
import SnapController from './snap/SnapController';
import ToolController from './tools/ToolController';
import TopoEditorController from './edit/TopoEditorController';

/**
 * NaviMap地图类，是对leaflet的map的扩展
 */
export default class Map extends LMap {
    /**
     * 地图构造方法
     * @param {String} id      地图Id
     * @param {Object} options 可选项
     */
    constructor(id, options) {
        super(id, options);

        this._initComponents();
    }

    /**
     * 初始化地图组件
     */
    _initComponents() {
        // 资源管理器
        const factory = new Factory({
            mode: 1,
            capacity: 1000
        });
        // 图片加载器
        const imageLoader = new ImageLoader(factory);
        imageLoader.addTo(this);

        // 瓦片管理器
        const tileManager = new TileManager();
        tileManager.addTo(this);

        // 几何转换工具
        const geojsonConverter = new GeojsonConverter();
        geojsonConverter.addTo(this);

        // 数据源管理器
        const sourceController = new SourceController();
        sourceController.addTo(this);

        // 反馈绘制管理器
        const feedbackController = new FeedbackController();
        feedbackController.addTo(this);

        // 数据搜索管理器
        const featureSelector = new FeatureSelector();
        featureSelector.addTo(this);

        // 数据捕捉管理器
        const snapController = new SnapController();
        snapController.addTo(this);

        // 工具管理器
        const toolController = new ToolController();
        toolController.addTo(this);

        // 编辑器管理器
        const topoEditorController = new TopoEditorController();
        topoEditorController.addTo(this);
        
        // 高亮
        const highlightController = new HighlightController();
        highlightController.addTo(this);

        // ID高亮
        const idHighlightController = new IDHighlightController();
        idHighlightController.addTo(this);
    }

    /**
     * 添加组件
     * @param {object} component 组件实例
     */
    addComponent(component) {
        if (component) {
            this[component.constructor.name] = component;
            component.onAdd(this);
        }
    }

    /**
     * 删除组件
     * @param {object} component 组件实例
     */
    removeComponent(component) {
        if (component) {
            component.onRemove(this);
            delete this[component.constructor.name];
        }
    }

    /**
     * 获取geojson格式的地图屏幕范围矩形
     * @returns {object} geojson
     */
    getBoundsGeo() {
        const bounds = this.getBounds();
        const sw = bounds.getSouthWest();
        const nw = bounds.getNorthWest();
        const ne = bounds.getNorthEast();
        const se = bounds.getSouthEast();

        return {
            type: 'Polygon',
            coordinates: [
                [
                    [sw.lng, sw.lat],
                    [se.lng, se.lat],
                    [ne.lng, ne.lat],
                    [nw.lng, nw.lat],
                    [sw.lng, sw.lat]
                ]
            ]
        };
    }

    /**
     * 获取整数的缩放等级，对实际的缩放等级进行四舍五入
     */
    getZoomLevel() {
        return Math.round(this.getZoom());
    }
}
